import ProductImageGallery from './lib/ProductImageGallery';

export default ProductImageGallery;
